import { Search, X } from 'lucide-react';
import { useState } from 'react';
import { Button, FormField, FormLabel, FormInput, FormSelect } from '../ui';
import type { RepresentativeFilters as Filters } from '../../types/representative';

interface RepresentativeFiltersProps {
  onFilter: (filters: Filters) => void;
  initialFilters?: Filters;
}

function RepresentativeFilters({ onFilter, initialFilters }: RepresentativeFiltersProps) {
  const [search, setSearch] = useState(initialFilters?.search || '');
  const [active, setActive] = useState<string>(
    initialFilters?.active !== undefined ? initialFilters.active.toString() : ''
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onFilter({
      search: search || undefined,
      active: active ? active === 'true' : undefined,
    });
  };

  const handleClear = () => {
    setSearch('');
    setActive('');
    onFilter({});
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white dark:bg-gray-800 shadow rounded-lg p-4 mb-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormField>
          <FormLabel htmlFor="search">Buscar</FormLabel>
          <FormInput
            id="search"
            type="text"
            placeholder="Nome, e-mail ou telefone"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="active">Status</FormLabel>
          <FormSelect
            id="active"
            value={active}
            onChange={(e) => setActive(e.target.value)}
          >
            <option value="">Todos</option>
            <option value="true">Ativo</option>
            <option value="false">Inativo</option>
          </FormSelect>
        </FormField>

        <FormField>
          <FormLabel className="invisible">Ações</FormLabel>
          <div className="flex gap-2">
            <Button type="submit" className="flex-1">
              <Search className="h-4 w-4 mr-2" />
              Filtrar
            </Button>
            <Button type="button" variant="secondary" onClick={handleClear}>
              <X className="h-4 w-4" />
            </Button>
          </div>
        </FormField>
      </div>
    </form>
  );
}

export default RepresentativeFilters;
